import api from '@/store/helpers/api';

export default {
  state: {
    dashboard: {
      modules: [],
      customers: [],
      globalUsers: [], // action está no módulo users.js
    },
  },
  mutations: {
    SET_DASHBOARD_CUSTOMERS(state, customers) {
      state.dashboard.customers = customers;
    },
    SET_DASHBOARD_MODULES(state, modules) {
      state.dashboard.modules = modules;
    },
    SET_DASHBOARD_GLOBAL_USERS(state, globalUsers) {
      state.dashboard.globalUsers = globalUsers;
    },
  },
  actions: {
    loadDashboardCustomers({ commit }) {
      commit('SET_LOADING_STATE', true);

      return new Promise((resolve, reject) => {
        api
          .get('dashboard/admin/customer')
          .then((response) => {
            const { data } = response;
            commit('SET_DASHBOARD_CUSTOMERS', data);
            resolve();
          })
          .catch(reject)
          .finally(() => commit('SET_LOADING_STATE', false));
      });
    },
    loadDashboardModules({ commit }) {
      commit('SET_LOADING_STATE', true);

      return new Promise((resolve, reject) => {
        api
          .get('dashboard/admin/modules')
          .then((response) => {
            const { data } = response;
            commit('SET_DASHBOARD_MODULES', data);
            resolve();
          })
          .catch(reject)
          .finally(() => commit('SET_LOADING_STATE', false));
      });
    },
    goToCustomer({ commit }, customer) {
      commit('SET_LOADING_STATE', true);

      return new Promise((resolve, reject) => {
        api
          .get(`auth/global/${customer}`)
          .then((response) => {
            const { accessToken } = response.data;
            localStorage.setItem('editor-token', accessToken);
            api.defaults.headers.common.Authorization = accessToken;
            resolve();
          })
          .catch(reject)
          .finally(() => commit('SET_LOADING_STATE', false));
      });
    },
  },
};
